import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom'
import { Home, CreditCard, Receipt, BarChart3, Settings, Gift } from 'lucide-react'
import { useAppLanguage } from '../../i18n'

export default function AccountPage() {
  const { t } = useAppLanguage()
  const location = useLocation()

  const tabs = [
    { to: '/account/overview', label: 'Vue d\'ensemble', icon: Home },
    { to: '/account/subscription', label: 'Abonnement', icon: CreditCard },
    { to: '/account/billing', label: 'Facturation', icon: Receipt },
    { to: '/account/usage', label: 'Utilisation', icon: BarChart3 },
    { to: '/account/affiliate', label: t.affiliate.navLabel, icon: Gift },
    { to: '/account/settings', label: 'Paramètres', icon: Settings },
  ]

  if (location.pathname === '/account') {
    return <Navigate to="/account/overview" replace />
  }

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Background gradient - STYLE_GUIDE.md */}
      <div aria-hidden className="absolute inset-0 -z-30 bg-gradient-to-b from-emerald-50 via-white to-white dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-900" />
      <div aria-hidden className="absolute inset-x-0 top-0 -z-40 h-[320px] bg-[radial-gradient(circle_at_top,_rgba(16,185,129,0.25),_transparent_68%)]" />
      <div aria-hidden className="absolute inset-0 -z-20 bg-[radial-gradient(circle_at_15%_18%,rgba(236,72,153,0.14),transparent_60%),radial-gradient(circle_at_85%_18%,rgba(168,85,247,0.17),transparent_55%)] dark:bg-[radial-gradient(circle_at_12%_18%,rgba(236,72,153,0.12),transparent_55%),radial-gradient(circle_at_88%_20%,rgba(168,85,247,0.15),transparent_50%)]" />

      <div className="relative mx-auto flex max-w-[1600px] flex-col gap-4 px-1 py-3 sm:px-6 sm:py-6">
        {/* Navigation Tabs */}
        <nav className="flex flex-wrap gap-2 rounded-2xl border border-emerald-100/70 bg-white/80 p-2 shadow-lg shadow-emerald-500/5 backdrop-blur-sm dark:border-emerald-900/50 dark:bg-zinc-900/80">
          {tabs.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition-all ${
                  isActive
                    ? 'bg-emerald-500 text-white shadow-md shadow-emerald-500/30'
                    : 'text-zinc-600 hover:bg-zinc-100 dark:text-zinc-400 dark:hover:bg-zinc-800'
                }`
              }
            >
              <Icon className="h-4 w-4" />
              <span className="hidden sm:inline">{label}</span>
            </NavLink>
          ))}
        </nav>

        {/* Content */}
        <div className="rounded-3xl border border-emerald-100/70 bg-white/90 p-6 shadow-xl shadow-emerald-500/10 dark:border-emerald-900/50 dark:bg-zinc-950/90 sm:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
